<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>工单管理</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="showInUserList">待分配工单</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!hideInDetails">
      <section class="searchBox">
        <span>
          <label>项目：</label>
          <a-select
            style="min-width:160px"
            v-model="project_id"
            showSearch
            :filterOption="filterOption"
          >
            <a-select-option
              v-for="element in proList"
              :key="element.id"
              :value="element.id"
              >{{ element.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>工单类型：</label>
          <a-select style="width: 100px" v-model="type">
            >
            <a-select-option :value="1">开荒</a-select-option>
            <a-select-option :value="2">双周</a-select-option>
            <a-select-option :value="3">深度</a-select-option>
            <a-select-option :value="4">退租</a-select-option>
          </a-select>
        </span>
        <span>
          <a-select
            defaultValue="1"
            style="width: 140px;margin-right:6px;"
            v-model="search_time_type"
          >
            <a-select-option :value="1">计划服务时间</a-select-option>
          </a-select>
          <a-range-picker
            v-model="dateDefault"
            @change="selectedDate"
            style="width:200px"
          />
        </span>
        <span>
          <label>注意事项：</label>
          <a-radio-group v-model="is_order_notice">
            <a-radio :value="2">是</a-radio>
            <a-radio :value="1">否</a-radio>
          </a-radio-group>
        </span>
        <span>
          <label>字符串：</label>
          <a>
            <a-input
              style="width:200px"
              v-model="nameSearch"
              placeholder="公寓名称 | 地址 | 员工姓名"
            />
          </a>
        </span>
        <span>
          <a-button style="margin-right:10px" @click="onReset">重置</a-button>
          <a-button
            style="margin-right:10px"
            type="primary"
            icon="search"
            @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data == ''">
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.project_name }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.plan_work_date }}</td>
              <td>
                <p v-if="item.type == 1">开荒</p>
                <p v-else-if="item.type == 2">双周</p>
                <p v-else-if="item.type == 3">深度</p>
                <p v-else-if="item.type == 4">退租</p>
              </td>
              <td class="operation">
                <a
                  @click="abnormal(item)"
                  v-show="item.status != 40 && item.status != 50"
                  >异常处理</a
                >
                <a
                  v-show="item.status == 20 || item.status == 10"
                  style="color:#F56C6C"
                  @click="attentionPage(item)"
                  >注意事项</a
                >
                <a style="color:#67C23A" @click="sendOrder(item)">派单</a>
                <a style="color:#909399" @click="detailPage(item)">详情</a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- 详情 -->
    <ordersDetail v-show="hideInDetails" :detailVal="detailVal" />
    <!-- 详情 end -->
    <!-- 异常处理 -->
    <aside class="abnormal" v-show="hideIsAbnormal">
      <div>
        <h3>异常处理</h3>
        <ul>
          <li>
            <label>公寓名称：</label>
            <span v-if="abnormalDetail != ''">{{ abnormalDetail.name }}</span>
          </li>
          <li>
            <label> <i>*</i>类型： </label>
            <a-radio-group v-model="result_type">
              <a-radio
                v-show="
                  abnormalDetail.status == 20 || abnormalDetail.status == 10
                "
                :value="1"
                >改期</a-radio
              >
              <a-radio
                v-show="
                  abnormalDetail.status == 20 || abnormalDetail.status == 10
                "
                :value="2"
                >退单</a-radio
              >
              <a-radio v-show="abnormalDetail.status == 30" :value="3"
                >返单</a-radio
              >
            </a-radio-group>
          </li>
          <li v-if="result_type == 1">
            <label> <i>*</i>计划服务时间： </label>
            <a-date-picker @change="changePlanDate" />
          </li>
          <li>
            <label> <i>*</i>备注： </label>
            <a-textarea
              v-model="result_reason"
              style="width:230px;vertical-align: top;"
              :auto-size="{ minRows: 3, maxRows: 5 }"
            />
          </li>
        </ul>
        <div>
          <a-button @click="abnormalCancel" class="resetStyle">取消</a-button>
          <a-button type="primary" @click="abnormalSure">确定</a-button>
        </div>
      </div>
    </aside>
    <!-- 异常处理 end -->
    <!-- 派单 -->
    <aside class="abnormal" v-show="changTurnSend">
      <div style="width:600px;margin:12% auto">
        <h3>派单</h3>
        <ul>
          <li>
            <label>公寓名称：</label>
            <span>{{ sendOrderDetail.name }}</span>
          </li>
          <li>
            <label> <i>*</i>选择员工： </label>
            <a-input
              style="width:300px"
              @click="selectUser"
              v-model="userName"
            />
            <ul class="workerList" v-show="isShowWorkList">
              <li
                @click="selectedUser(element)"
                v-show="userList != ''"
                v-for="(element, k) in userList"
                :key="k"
              >
                <div class="info">
                  <div>
                    <h2>{{ element.name }}</h2>
                    <p>{{ "&nbsp;&nbsp;&nbsp;" + element.phone }}</p>
                    <p v-if="element.gender == 1">&nbsp;&nbsp;&nbsp;男</p>
                    <p v-else-if="element.gender == 2">&nbsp;&nbsp;&nbsp;女</p>
                  </div>
                </div>
                <ul class="list">
                  <li>
                    <label>现居地：</label>
                    <p>
                      {{
                        element.province == element.city
                          ? element.city + element.area + element.address
                          : element.province +
                            element.city +
                            element.area +
                            element.address
                      }}
                    </p>
                  </li>
                  <li>
                    <label>待完成工单：</label>
                    <p v-show="element.no_finish_list == ''">无</p>
                    <span v-show="element.no_finish_list.length > 0"
                      >【&nbsp;</span
                    >
                    <p
                      v-show="element.no_finish_list.length > 0"
                      v-for="(item, l) in element.no_finish_list"
                      :key="l"
                    >
                      <span v-if="item.type == 1">{{
                        "开荒：" + item.count_num
                      }}</span>
                      <span v-else-if="item.type == 2">{{
                        "&nbsp;&nbsp;双周：" + item.count_num
                      }}</span>
                      <span v-else-if="item.type == 3">{{
                        "&nbsp;&nbsp;深度：" + item.count_num
                      }}</span>
                      <span v-else-if="item.type == 4">{{
                        "&nbsp;&nbsp;退租：" + item.count_num
                      }}</span>
                    </p>
                    <span v-show="element.no_finish_list.length > 0"
                      >&nbsp;】</span
                    >
                  </li>
                </ul>
              </li>
              <li v-show="userList == ''">暂无</li>
            </ul>
          </li>
          <li>
            <label>备注：</label>
            <a-textarea
              v-model="sendOrderRemark"
              :auto-size="{ minRows: 3, maxRows: 5 }"
            />
          </li>
        </ul>
        <div style="margin-top:52px">
          <a-button @click="turnSendCancel" class="resetStyle">取消</a-button>
          <a-button type="primary" @click="turnSendSure">确定</a-button>
        </div>
      </div>
    </aside>
    <!-- 派单 end -->
    <!-- 注意事项 -->
    <aside class="abnormal attention" v-show="attentionIsShow">
      <div>
        <h3>注意事项</h3>
        <ul v-if="attentionDetail != ''">
          <li>
            <label>公寓名称：</label>
            <span>{{ attentionDetail.name }}</span>
          </li>
          <li>
            <label> <i>*</i>内容： </label>
            <a-textarea
              v-model="noticeContent"
              style="width:230px;vertical-align: top;"
              :auto-size="{ minRows: 3, maxRows: 5 }"
            />
          </li>
          <li class="upImgStyle">
            <label> <i>*</i>图片： </label>
            <div>
              <input
                id="travel"
                type="file"
                accept="image/*"
                @change="attentionPic"
              />
              <label for="travel">
                <a-icon type="plus" style="color:#d9d9d9;font-size:40px" />
              </label>
              <ul>
                <li
                  v-show="imageAttentionlUrl != ''"
                  v-for="(item, l) in imageAttentionlUrl"
                  :key="l"
                >
                  <img :src="item" alt />
                  <a-icon
                    @click="deleteAttention(l)"
                    class="close"
                    type="close"
                  />
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <div>
          <a-button @click="attentionCancel" class="resetStyle">取消</a-button>
          <a-button type="primary" @click="NoticeSure">确定</a-button>
        </div>
      </div>
    </aside>
    <!-- 注意事项 end  -->
    <!-- 结算 -->

    <!-- 结算 end -->
  </div>
</template>
<script>
import axios from "axios";
import ordersDetail from "@/components/clean/ordersDetail"; //详情
import { mapState } from "vuex";
import * as qiniu from "qiniu-js";
export default {
  components: {
    ordersDetail
  },
  data() {
    return {
      data: {},
      loading: false,
      page: 1,
      pagination: {},
      query_field: "",
      typeSearch: -1,
      editDetail: {},
      totalPage: Number,
      thList: ["项目名", "公寓名称", "计划时间", "工单类型", "操作"],
      hideInDetails: false,
      detailVal: {},
      abnormalDetail: {},
      hideIsAbnormal: false,
      result_type: "",
      result_reason: "",
      addTurnSendIsShow: false,
      addTaskSure: false,
      changTurnSend: false,
      attentionIsShow: false,
      attentionDetail: {},
      imageAttentionlUrl: [],
      plan_work_date: "",
      turnSendDetail: {},
      turnSendIds: [],
      turnSendNames: [],
      userList: [],
      userName: "",
      isShowWorkList: false,
      userID: "",
      getToken1: [],
      noticeContent: "",
      project_id: "",
      proList: "",
      search_time_type: 1,
      is_apply: 0,
      nameSearch: "",
      is_order_notice: 0,
      type: "",
      status: "",
      start_date: "",
      end_date: "",
      sendOrderDetail: {},
      sendOrderRemark: "",
      dateDefault: null
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    this.getData(); //获取列表
    this.getUser(); //获取员工
    this.getPro(); //获取项目
  },
  watch: {
    userName() {
      this.getUser(); //获取员工
    }
  },
  methods: {
    selectedDate(data, dataString) {
      this.start_date = dataString[0];
      this.end_date = dataString[1];
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 3
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data;
            //  console.log(this.proList);
          }
        });
    },
    selectUser() {
      this.isShowWorkList = true;
    },
    selectedUser(val) {
      this.isShowWorkList = false;
      this.userName = val.name;
      this.userID = val.user_id;
    },
    getUser() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.clean +
        "Work_order/getAllGuardData";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          query_field: this.userName
        })
        .then(res => {
          if (res.data.code == 200) {
            this.userList = res.data.data;
            // console.log(this.userList);
          }
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    settlementPage() {}, //结算
    attentionPic(e) {
      if (e.target.files != "") {
        this.getUpImgToken(e);
        let reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onloadend = () => {
          this.imageAttentionlUrl.push(reader.result);
          this.traveIsShow = false;
        };
      }
    }, //注意事项图片
    getUpImgToken(e) {
      let self = this;
      let url = this.httpsBasic.url + "cloud/Qiniu/getToken";
      axios
        .post(url, {
          count: 1
        })
        .then(res => {
          this.getToken1.push(res.data.data.business_file_key);
          // console.log(this.getToken1);
          var config = {
            useCdnDomain: true,
            region: qiniu.region.z0
          };
          var putExtra = {
            fname: "",
            params: {},
            mimeType: null
          };
          var observable = qiniu.upload(
            e.target.files[0],
            res.data.data.keys[0],
            res.data.data.token,
            putExtra,
            config
          );
          var observer = {
            next(res) {
              // console.log("上传中...");
            },
            error(err) {
              // console.log(err)
              self.$info({
                title: "提示",
                content: "错误码：" + err.code + "！请重新选择图片",
                onOk() {}
              });
              self.imageAttentionlUrl = "";
            },
            complete(res) {
              // console.log("上传成功");
            }
          };
          var subscription = observable.subscribe(observer); // 上传开始
        });
    }, //上传至七牛云
    deleteAttention(key) {
      this.imageAttentionlUrl.splice(key, 1);
      this.getToken1.splice(key, 1);
    }, //删除注意事项图片
    NoticeSure() {
      this.attentionDetail.is_order_notice == 2
        ? this.editNotice()
        : this.addNotice();
    }, //确认注意事项
    addNotice() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.clean +
        "Order_Notice/addOrderNotice";
      let params = {
        content: this.noticeContent,
        images: JSON.stringify(this.getToken1),
        clean_order_id: this.attentionDetail.id,
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.$message.success("处理成功");
          this.attentionIsShow = false;
          this.getToken1 = [];
          this.noticeContent = "";
          this.reload();
        } else {
          this.$message.error(res.data.message);
        }
      });
    }, //注意事项添加
    editNotice() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.clean +
        "Order_Notice/editOrderNotice";
      let params = {
        content: this.noticeContent,
        images: JSON.stringify(this.getToken1),
        id: this.attentionDetail.order_notice_id,
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.$message.success("处理成功");
          this.attentionIsShow = false;
          this.getToken1 = [];
          this.noticeContent = "";
          this.reload();
        } else {
          this.$message.error(res.data.message);
        }
      });
    }, //注意事项删除
    attentionPage(val) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.attentionDetail = val;
      this.attentionIsShow = true;
      // console.log(val);
      this.imageAttentionlUrl = [];
      this.getToken1 = [];
      this.noticeContent = "";
      if (val.is_order_notice == 2) {
        this.noticeContent = val.content;
        val.images_fmt.forEach(item => {
          this.imageAttentionlUrl.push(item.url_thumb);
          this.getToken1 = JSON.parse(val.images);
        });
      }
    }, //显示注意事项弹框
    attentionCancel() {
      this.attentionIsShow = false;
    }, //取消注意事项
    turnSendCancel() {
      this.userName = "";
      this.isShowWorkList = false;
      this.changTurnSend = false;
    }, //弹框-取消转派
    turnSendSure() {
      if (this.userID != "") {
        let url =
          this.httpsBasic.url +
          this.httpsBasic.clean +
          "Work_order/assignOrderByOrder";
        let params = {
          token: window.localStorage.getItem("xnwfPcToken"),
          id: this.sendOrderDetail.id,
          user_id: this.userID,
          remark: this.sendOrderRemark
        };
        axios.post(url, params).then(res => {
          if (res.data.code == 200) {
            this.$message.success("派单成功");
            this.changTurnSend = false;
            this.reload();
          } else {
            this.$message.error(res.data.message);
          }
        });
      } else {
        this.$message.warning("请选择转派员工！");
      }
    }, //弹框-确定转派
    sendOrder(val) {
      this.sendOrderDetail = val;
      this.changTurnSend = true;
    }, //确定转派
    changePlanDate(data, dataString) {
      this.plan_work_date = dataString;
    }, //选择计划服务时间
    abnormal(val) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.abnormalDetail = val;
      this.hideIsAbnormal = true;
    }, //显示异常处理弹框
    abnormalCancel() {
      this.result_type = "";
      this.result_reason = "";
      this.plan_work_date = "";
      this.hideIsAbnormal = false;
    }, //取消异常处理
    abnormalSure() {
      let _this = this;
      if (this.result_type != "" && this.result_reason != "") {
        this.hideIsAbnormal = false;
        this.$confirm({
          title: "提示?",
          content: "是否确认对该工单进行异常处理！",
          onOk() {
            _this.abnormalHttp();
          },
          onCancel() {}
        });
      } else {
        this.$message.error("标记*为必填项！");
      }
    }, //确定异常处理
    abnormalHttp() {
      let url =
        this.httpsBasic.url + this.httpsBasic.clean + "Work_order/handle";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        result_type: this.result_type,
        result_reason: this.result_reason,
        plan_work_date: this.plan_work_date,
        id: this.abnormalDetail.id
      };
      if (this.result_type != 1) {
        delete params.plan_work_date;
      }
      // console.log(params);
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.$message.success("处理成功");
          this.abnormalCancel = false;
          this.reload();
        } else {
          this.$message.error(res.data.message);
        }
      });
    }, //再次确认异常处理，请求接口
    detailPage(val) {
      this.detailVal = val;
      this.hideInDetails = true;
    }, //详情
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    }, //分页
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    showInUserList() {
      this.hideInDetails = false;
    },
    onSearch(value) {
      this.page = 1;
      // this.query_field = value;
      this.getData();
      // console.log(value);
    },
    onReset() {
      this.dateDefault = undefined;
      this.nameSearch = "";
      this.status = "";
      this.project_id = "";
      this.search_time_type = 1;
      this.is_apply = 0;
      this.is_order_notice = 0;
      this.start_date = "";
      this.end_date = "";
      this.type = "";
      this.page = 1;
      this.getData();
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      this.data = [];
      let url =
        this.httpsBasic.url +
        this.httpsBasic.clean +
        "Work_order/adminWaitList";
      axios
        .post(url, {
          current_page: this.page,
          per_page: 10,
          query_field: this.nameSearch,
          status: this.status,
          project_id: this.project_id,
          search_time_type: this.search_time_type,
          is_apply: this.is_apply,
          type: this.type,
          is_order_notice: this.is_order_notice,
          start_date: this.start_date,
          end_date: this.end_date,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  .workerList {
    background: #ffffcc;
    line-height: 24px;
    font-size: 12px;
    padding: 10px 10px 0;
    margin: 0 0 0 84px;
    max-height: 300px;
    overflow-y: scroll;
    position: absolute;
    width: 312px;
    z-index: 1;
    > li {
      margin-bottom: 10px;
      padding-bottom: 10px;
      border-bottom: 1px dotted #ff6666;
      cursor: pointer;
    }
    > li:last-child {
      margin-bottom: 0;
      border-bottom: none;
    }
    label {
      font-size: 12px;
    }
  }
  .info {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    > div {
      display: flex;
      flex-direction: row;
      align-content: center;
      h2 {
        font-weight: normal;
        margin-bottom: 0;
      }
    }
    > a {
      border: 1px solid #ccc;
      display: inline-block;
      height: 24px;
    }
  }
  .list {
    > li {
      display: flex;
      flex-direction: row;
    }
  }
  .searchBox {
    display: block;
    > span {
      display: inline-block;
      margin-right: 20px;
      margin-bottom: 10px;
      a,
      label {
        display: inline-block;
      }
    }
  }
  .assignedBox {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1;
    h3 {
      font-size: 14px;
      text-align: center;
      margin: 10px 0 20px;
    }
    > div {
      background: #fff;
      margin: 12% 30%;
      padding: 20px 4% 40px;
      border-radius: 10px;
      ul {
        li {
          margin-bottom: 10px;
          i {
            font-style: normal;
            color: red;
            display: inline-block;
            margin-right: 4px;
          }
        }
      }
      > div {
        margin-top: 30px;
        button {
          margin-right: 12px;
        }
      }
    }
  }
}
.abnormal {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
  h3 {
    font-size: 14px;
    text-align: center;
    margin: 10px 0 20px;
  }
  > div {
    background: #fff;
    margin: 12% 28%;
    padding: 20px 4% 40px;
    border-radius: 10px;
    > div {
      display: flex;
      flex-direction: row;
      justify-content: center;
    }
    > ul {
      > li {
        margin-bottom: 10px;
        i {
          font-style: normal;
          color: red;
          display: inline-block;
          margin-right: 4px;
        }
      }
    }
    > div {
      margin-top: 30px;
      button {
        margin-right: 12px;
      }
    }
  }
}
// .attention {
//   > div {
//     margin: 12px 20%;
//   }
// }
.changeTask {
  img {
    height: 16px;
  }
}
.upImgStyle {
  > div {
    position: relative;
    display: inline-block;
    min-width: 300px;
    vertical-align: top;
    > input {
      vertical-align: top;
      opacity: 0;
      position: absolute;
    }
    > label {
      vertical-align: top;
      display: inline-block;
      border: 1px solid #d9d9d9;
      width: 100px;
      height: 100px;
      text-align: center;
      line-height: 100px;
      margin-right: 10px;
      margin-top: 10px;
    }
    > ul {
      display: inline-block;
      li {
        display: inline-block;
        position: relative;
        margin-top: 10px;
        img {
          display: inline-block;
          width: 100px;
          height: 100px;
          object-fit: cover;
          margin-right: 10px;
          border: 1px solid #d9d9d9;
          margin-bottom: 10px;
        }
        .close {
          position: absolute;
          right: 8px;
          top: 2px;
          font-size: 24px;
          color: #333;
        }
      }
    }
  }
}
</style>
<style lang="less">
.ant-table {
  min-height: 58vh;
}
</style>
